import { render, staticRenderFns } from "./DealerInfoView.vue?vue&type=template&id=23385b4e&scoped=true&"
import script from "./DealerInfoView.vue?vue&type=script&lang=js&"
export * from "./DealerInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23385b4e",
  null
  
)

export default component.exports